(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7695],{

/***/ 20935:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events",
      function () {
        return __webpack_require__(35775);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$0": function() { return /* binding */ Section; },
/* harmony export */   "$C": function() { return /* binding */ ModuleTitle; },
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "Pu": function() { return /* binding */ CenterOnSmallScreen; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19521);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22745);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52873);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 3rem 0;\n\n      ",
        " {\n        font-size: 24px;\n        margin-bottom: 3rem;\n        text-align: center;\n\n        &::after {\n          left: 50%;\n          bottom: -10px;\n          margin-left: -1.5rem;\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  background: ",
        ";\n  padding: 4rem 0 6rem;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 32px;\n  margin-bottom: 4rem;\n\n  && {\n    font-weight: normal;\n  }\n\n  &::after {\n    ",
        ";\n    content: '';\n    background: ",
        ";\n    position: absolute;\n    bottom: -6px;\n    left: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: ",
        ";\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  justify-content: space-between;\n  line-height: 1;\n  font-size: 20px;\n  font-weight: normal !important;\n  margin-bottom: 2rem;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n      text-align: center;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var Section = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject1(), _colors__WEBPACK_IMPORTED_MODULE_1__.F1, _colors__WEBPACK_IMPORTED_MODULE_1__.M1, function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject(), Title);
});
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject2(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .responsive */ .jW());
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2 */ .ZP.h2(_templateObject3(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .size */ .dp("3rem", "10px"), _colors__WEBPACK_IMPORTED_MODULE_1__.B1);
var ModuleTitle = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3 */ .ZP.h3(_templateObject5(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .flexVerticalCenter */ .VL(), function(props) {
    return props.justify && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject4(), props.justify);
});
var Text = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject6(), _colors__WEBPACK_IMPORTED_MODULE_1__.F2);
var CenterOnSmallScreen = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].div */ .ZP.div(_templateObject8(), function(props) {
    return props.isSmallScreen && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)(_templateObject7(), _mixins__WEBPACK_IMPORTED_MODULE_2__/* .centerBlock */ .EM());
});


/***/ }),

/***/ 580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Anchor; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function Anchor(_param) {
    var target = _param.target, rel = _param.rel, isHash = _param.isHash, href = _param.href, rest = _objectWithoutProperties(_param, [
        "target",
        "rel",
        "isHash",
        "href"
    ]);
    var props = _objectSpread({}, rest);
    //const isInternalLink = rest.href.charAt(0) === '/'
    //const hasHash = props.href.includes('#') && isInternalLink
    props.target = isHash ? "" : target !== null && target !== void 0 ? target : "_blank";
    props.rel = isHash ? "" : rel !== null && rel !== void 0 ? rel : "noopener noreferrer";
    // Add path prefix
    if (href && href.startsWith("/") && !href.startsWith("//") && !href.startsWith("/tidbcommunity")) {
        href = "/tidbcommunity" + href;
    }
    props.href = href;
    var _children;
    var children = (_children = props.children) !== null && _children !== void 0 ? _children : props.href;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", _objectSpread({}, props, {
        children: children
    }));
};


/***/ }),

/***/ 66327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75302);

var useIsSmallScreen = function() {
    var breakpoint = antd__WEBPACK_IMPORTED_MODULE_0__/* ["default"].useBreakpoint */ .ZP.useBreakpoint();
    return {
        isSmallScreen: !breakpoint.md,
        breakpoint: breakpoint
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useIsSmallScreen);


/***/ }),

/***/ 89501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TwoColumnsSection_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/twoColumnsSection.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Content = styled/* Content */.VY, Title = styled/* Title */.Dx;

var LeftPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        xs: {
            span: 24,
            order: props.$reverseOnSmallScreen ? 2 : 1
        },
        md: {
            span: 13,
            order: 1
        }
    };
})(_templateObject());
var RightPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        xs: {
            span: 24,
            order: props.$reverseOnSmallScreen ? 1 : 2
        },
        md: {
            span: 8,
            order: 2
        }
    };
})(_templateObject1());

;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/TwoColumnsSection.component.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var TwoColumnsSection = function(props) {
    var title = props.title, leftPanel = props.leftPanel, rightPanel = props.rightPanel, $reverseOnSmallScreen = props.$reverseOnSmallScreen, rest = _objectWithoutProperties(props, [
        "title",
        "leftPanel",
        "rightPanel",
        "$reverseOnSmallScreen"
    ]);
    var panelProps = {
        $reverseOnSmallScreen: $reverseOnSmallScreen
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, _objectSpread({}, rest, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPanel, _objectSpread({}, panelProps, {
                        children: leftPanel
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPanel, _objectSpread({}, panelProps, {
                        children: rightPanel
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ var TwoColumnsSection_component = (TwoColumnsSection);

;// CONCATENATED MODULE: ./src/layouts/twoColumnsSection/index.ts



/***/ }),

/***/ 35775:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ EventsIndexPage; },
  "defaultPageSize": function() { return /* binding */ index_page_defaultPageSize; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./src/layouts/index.js + 12 modules
var layouts = __webpack_require__(70230);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/ahooks/es/useSize/index.js + 10 modules
var useSize = __webpack_require__(98126);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
// EXTERNAL MODULE: ./src/hooks/useIsSmallScreen.js
var useIsSmallScreen = __webpack_require__(66327);
// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
;// CONCATENATED MODULE: ./src/pages/events/index/about/about.styled.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  &:not(:last-child) {\n    margin-bottom: 4rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: 4rem;\n\n  p {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n  \n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  overflow: hidden;\n  &:not(:first-child) {\n    margin-top: 32px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 150px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 1rem 2rem;\n  max-height: 250px;\n\n  h3,\n  p {\n    margin-bottom: 1rem;\n  }\n\n  h3 {\n    font-size: 20px;\n    font-weight: normal;\n    line-height: 1.2;\n  }\n\n  p {\n    font-size: 14px;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n  padding: 20px;\n  border-radius: 6px;\n  border: 1px solid ",
        ";\n  background: ",
        ";\n  overflow: hidden;\n  .fc-button-primary {\n    color: #1e2b37;\n    background-color: rgba(0, 0, 0, 0) !important;\n    border: none !important;\n    height: 40px !important;\n  }\n  .fc-button-primary:hover,\n  .fc-button-primary:active,\n  .fc-button-primary:focus {\n    color: #1e2b37 !important;\n    box-shadow: 0 0 0 0 !important;\n  }\n  .fc-event-main {\n    height: 14px;\n    line-height: 14px;\n    font-size: 12px;\n  }\n  .fc-daygrid-event {\n    border: none !important;\n  }\n  .fc-daygrid-day-number {\n    &:hover {\n      color: ",
        ";\n    }\n  }\n  .fc-col-header-cell-cushion {\n    cursor: default;\n    &:hover {\n      color: #1e2b37;\n    }\n    font-weight: 400;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var Content = styled/* Content */.VY, Section = styled/* Section */.$0, Title = styled/* Title */.Dx;

var Container = (0,styled_components_browser_esm/* default */.ZP)(Section)(_templateObject(), colors.M2);
var LeftPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    sm: {
        span: 24,
        order: 2
    },
    md: {
        span: 12,
        order: 1
    }
})(_templateObject1());
var RightPanel = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    sm: {
        span: 24,
        order: 1
    },
    md: {
        span: 12,
        order: 2
    }
})(_templateObject2());
var TopSection = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var Desc = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var CardList = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5());
var Card = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z)(_templateObject6(), mixins/* boxShadow */.Wn(), colors.T2, colors.M1);
var CardImg = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        span: props.$isVertical ? 24 : 12
    };
})(_templateObject7());
var CardInfo = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs(function(props) {
    return {
        span: props.$isVertical ? 24 : 12
    };
})(_templateObject8(), colors.F2);
var CalendarCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject9(), mixins/* boxShadow */.Wn(), colors.T2, colors.M1, colors.B1);

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 44 modules
var es_select = __webpack_require__(18963);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 14 modules
var es_form = __webpack_require__(8289);
// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 5 modules
var tooltip = __webpack_require__(36084);
// EXTERNAL MODULE: ./node_modules/antd/es/empty/index.js + 2 modules
var empty = __webpack_require__(62986);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/EnvironmentOutlined.js + 1 modules
var EnvironmentOutlined = __webpack_require__(33862);
// EXTERNAL MODULE: ./node_modules/antd/es/pagination/index.js + 10 modules
var pagination = __webpack_require__(565);
;// CONCATENATED MODULE: ./src/pages/events/index/list/list.styled.ts
function list_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function list_styled_templateObject() {
    var data = list_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    list_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function list_styled_templateObject1() {
    var data = list_styled_taggedTemplateLiteral([
        "\n  margin-bottom: 2rem;\n"
    ]);
    list_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function list_styled_templateObject2() {
    var data = list_styled_taggedTemplateLiteral([
        "\n  .ant-select {\n    width: 100%;\n  }\n"
    ]);
    list_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function list_styled_templateObject3() {
    var data = list_styled_taggedTemplateLiteral([
        "\n  h3 {\n    font-size: 18px;\n    font-weight: normal;\n    line-height: 1.5;\n    margin-bottom: 0.5rem;\n  }\n\n  ul {\n    ",
        ";\n    list-style: none;\n\n    .anticon {\n      margin-right: 5px;\n    }\n\n    li {\n      line-height: 1.2;\n      font-size: 14px;\n      display: inline-block;\n      padding-right: 0.25rem;\n      margin-right: 0.25rem;\n      color: ",
        ";\n      border-right: 1px solid ",
        ";\n\n      &:last-child {\n        padding-left: 0;\n        margin-right: 0;\n        border-right: none;\n      }\n    }\n  }\n"
    ]);
    list_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function list_styled_templateObject4() {
    var data = list_styled_taggedTemplateLiteral([
        "\n  border-radius: 6px;\n  position: relative;\n  overflow: hidden;\n  height: 150px;\n  margin-bottom: 0.5rem;\n"
    ]);
    list_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function list_styled_templateObject5() {
    var data = list_styled_taggedTemplateLiteral([
        "\n  ",
        ";\n  margin: 3.5rem auto;\n"
    ]);
    list_styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function list_styled_templateObject6() {
    var data = list_styled_taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n  text-align: center;\n"
    ]);
    list_styled_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var list_styled_Content = styled/* Content */.VY, list_styled_Section = styled/* Section */.$0, list_styled_Title = styled/* Title */.Dx;

var list_styled_Container = (0,styled_components_browser_esm/* default */.ZP)(list_styled_Section)(list_styled_templateObject(), mixins/* responsive */.jW());
var Filters = (0,styled_components_browser_esm/* default */.ZP)(es_form/* default */.Z)(list_styled_templateObject1());
var DropdownWrapper = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    xs: 24,
    md: 6
})(list_styled_templateObject2());
var EventCard = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).attrs({
    xs: 24,
    sm: 12,
    md: 8,
    lg: 6
})(list_styled_templateObject3(), mixins/* reset */.mc(), colors.F2, colors.F2);
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(list_styled_templateObject4());
var SpinContainer = styled_components_browser_esm/* default.div */.ZP.div(list_styled_templateObject5(), mixins/* flexCenter */._7());
var Pagination = (0,styled_components_browser_esm/* default */.ZP)(pagination/* default */.Z).attrs({
    size: "small"
})(list_styled_templateObject6());

;// CONCATENATED MODULE: ./src/pages/events/index/data.ts
var CATEGORIES = [
    "\u6240\u6709\u7C7B\u578B",
    "meetup",
    "\u5F00\u53D1\u8005\u6D3B\u52A8/\u7ADE\u8D5B"
];
var TYPES = [
    "\u7EBF\u4E0A/\u7EBF\u4E0B",
    "\u7EBF\u4E0A",
    "\u7EBF\u4E0B"
];
var DATES = [
    "\u6240\u6709\u65F6\u95F4",
    "2021",
    "2020",
    "2019",
    "\u66F4\u65E9"
];
var LOCATIONS = [
    "\u5168\u7403",
    "\u5317\u4EAC",
    "\u4E0A\u6D77",
    "\u676D\u5DDE",
    "\u6DF1\u5733",
    "\u5E7F\u5DDE",
    "\u6210\u90FD",
    "\u5176\u4ED6"
];

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/utils/request.utils.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function getNumberFromQuery(item, defaultValue) {
    var value;
    if (item) {
        value = item;
    } else if (item === null || item === void 0 ? void 0 : item[0]) {
        value = item[0];
    } else {
        return defaultValue;
    }
    var number = Number(value);
    return isNaN(number) ? defaultValue : number;
}
function setUndefinedWhenItemIsEmpty(query) {
    var processedQuery = _objectSpread({}, query);
    for(var key in processedQuery){
        if (processedQuery[key] === "") {
            processedQuery[key] = undefined;
        }
    }
    return processedQuery;
}

;// CONCATENATED MODULE: ./src/pages/events/index/list/List.component.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function List_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function List_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            List_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}















var Option = es_select/* default.Option */.Z.Option;
var defaultPageSize = 8;
var Dropdown = function(param) {
    var name = param.name, placeholder = param.placeholder, options = param.options, setFiltersValue = param.setFiltersValue;
    var router = (0,next_router.useRouter)();
    var handleChangeFilter = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(value) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", setFiltersValue(function(state) {
                            return List_component_objectSpread({}, state, List_component_defineProperty({}, name, value));
                        }));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChangeFilter(value) {
            return _ref.apply(this, arguments);
        };
    }();
    var defaultValue = setUndefinedWhenItemIsEmpty(router.query)[name];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_form/* default.Item */.Z.Item, {
            name: name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* default */.Z, {
                placeholder: placeholder,
                onChange: handleChangeFilter,
                defaultValue: defaultValue,
                children: utils/* common.genOptionValues */.y0.genOptionValues(options).map(function(props) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, List_component_objectSpread({}, props), props.value);
                })
            })
        })
    });
};
var Event = function(param) {
    var title = param.title, link = param.link, location = param.location, type = param.type, date = param.date, endDate = param.endDate, startDate = param.startDate, image = param.image;
    var dateObj = startDate !== null && startDate !== void 0 ? startDate : date;
    var durationObj;
    if (endDate && startDate) {
        durationObj = dayjs_min_default()(endDate).diff(dayjs_min_default()(startDate), "days") + 1;
    } else if (date) {
        durationObj = null;
    } else {
        durationObj = null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCard, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Anchor/* default */.Z, {
            href: link,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        unoptimized: true,
                        alt: title,
                        src: image,
                        layout: "fill",
                        objectFit: "cover",
                        priority: true,
                        placeholder: "blur",
                        blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8WQ8AAjcBWtrfQHkAAAAASUVORK5CYII="
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tooltip/* default */.Z, {
                                placement: "topLeft",
                                title: "\u6D3B\u52A8\u7C7B\u578B",
                                arrowPointAtCenter: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EnvironmentOutlined/* default */.Z, {}),
                                    location
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                placement: "topLeft",
                                title: "\u6D3B\u52A8\u5F62\u5F0F",
                                arrowPointAtCenter: true,
                                children: type
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
                                placement: "topLeft",
                                title: "\u6D3B\u52A8\u65F6\u95F4",
                                arrowPointAtCenter: true,
                                children: dayjs_min_default()(dateObj).format("YYYY.MM.DD")
                            })
                        }),
                        durationObj && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(tooltip/* default */.Z, {
                                placement: "topLeft",
                                title: "\u6D3B\u52A8\u6301\u7EED\u5929\u6570",
                                arrowPointAtCenter: true,
                                children: [
                                    durationObj,
                                    " \u5929"
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/*const loadingStatus = (
  <Styled.SpinContainer>
    <Spin size="large" />
  </Styled.SpinContainer>
)*/ var htmlId = "all-events";
function List(param) {
    var events = param.events, total = param.total;
    var router = (0,next_router.useRouter)();
    var _query = router.query, category = _query.category, type = _query.type, date = _query.date, location = _query.location, pageNumberStr = _query.pageNumber;
    var pageNumber = getNumberFromQuery(pageNumberStr, 1);
    var ref = (0,react.useState)({
        category: category,
        type: type,
        date: date,
        location: location
    }), filtersValue = ref[0], setFiltersValue = ref[1];
    var ref1 = (0,useIsSmallScreen/* default */.Z)(), isSmallScreen = ref1.isSmallScreen, breakpoint = ref1.breakpoint;
    var handleFilter = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return router.replace({
                            pathname: "/events",
                            query: List_component_objectSpread({}, filtersValue, {
                                pageNumber: 1
                            }),
                            hash: "#".concat(htmlId)
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFilter() {
            return _ref.apply(this, arguments);
        };
    }();
    /*  useEffect(() => {
    if (!breakpoint.lg) {
      dispatch(actions.setPageSize(breakpoint.xs ? 3 : 6));
    } else {
      dispatch(actions.setPageSize(initialState.pageSize));
    }
  }, [dispatch, breakpoint]);*/ var handleChangePage = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(page) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return router.push({
                            pathname: "/events",
                            query: List_component_objectSpread({}, router.query, {
                                pageNumber: page
                            }),
                            hash: "#".concat(htmlId)
                        });
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChangePage(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var isMobile = !breakpoint.md;
    var filtersColProps = isMobile ? {
        span: 24
    } : {
        flex: "auto"
    };
    var buttonColProps = isMobile ? {
        span: 24
    } : {
        flex: "none"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(list_styled_Container, {
        id: htmlId,
        isSmallScreen: isSmallScreen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(list_styled_Title, {
                children: "\u6240\u6709\u6D3B\u52A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Filters, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                    gutter: [
                        16,
                        16
                    ],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, List_component_objectSpread({}, filtersColProps, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                gutter: [
                                    16,
                                    16
                                ],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                                        name: "category",
                                        placeholder: "\u6D3B\u52A8\u7C7B\u578B",
                                        options: CATEGORIES,
                                        setFiltersValue: setFiltersValue
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                                        name: "type",
                                        placeholder: "\u6D3B\u52A8\u5F62\u5F0F",
                                        options: TYPES,
                                        setFiltersValue: setFiltersValue
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                                        name: "date",
                                        placeholder: "\u6D3B\u52A8\u65F6\u95F4",
                                        options: DATES,
                                        setFiltersValue: setFiltersValue
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
                                        name: "location",
                                        placeholder: "\u6D3B\u52A8\u5730\u70B9",
                                        options: LOCATIONS,
                                        setFiltersValue: setFiltersValue
                                    })
                                ]
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, List_component_objectSpread({}, buttonColProps, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                type: "primary",
                                size: "small",
                                block: isMobile,
                                onClick: handleFilter,
                                children: "\u7B5B\u9009"
                            })
                        }))
                    ]
                })
            }),
            events.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                gutter: [
                    32,
                    32
                ],
                children: events.map(function(event, idx) {
                    var props = List_component_objectSpread({
                        key: idx
                    }, event, {
                        image: utils/* common.getStrapiImgProps */.y0.getStrapiImgProps(event.image)
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Event, List_component_objectSpread({}, props));
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(empty/* default */.Z, {
                description: "\u6CA1\u6709\u7B26\u5408\u6761\u4EF6\u7684\u6D3B\u52A8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination, {
                total: total,
                current: pageNumber,
                defaultPageSize: defaultPageSize,
                pageSize: defaultPageSize,
                onChange: handleChangePage,
                hideOnSinglePage: true,
                itemRender: function(page, type, originalElement) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            pathname: "/events",
                            query: List_component_objectSpread({}, router.query, {
                                pageNumber: page
                            })
                        },
                        passHref: true,
                        children: originalElement
                    });
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/events/index/about/About.component.tsx
function About_component_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function About_component_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            About_component_defineProperty(target, key, source[key]);
        });
    }
    return target;
}













var card = [
    {
        title: "2024 TiDB AI \u521B\u65B0\u5E94\u7528\u9ED1\u5BA2\u9A6C\u62C9\u677E",
        desc: "\u4E00\u8D77\u6765\u7528 TiDB \u6784\u5EFA\u672A\u6765\u7684 AI \u521B\u65B0\u5E94\u7528\uFF0C\u74DC\u5206\u8D85\uFFE5220,000 \u5956\u91D1\u6C60\uFF01",
        button: "\u524D\u5F80\u67E5\u770B",
        link: "https://pingkai.cn/tidbcommunity/forum/t/topic/1029569?utm_source=asktug&utm_medium=direct&utm_campaign=banner_04",
        image: "/images/activities/Hackathon_2024.jpeg"
    },
    {
        title: "TiDB \u5730\u533A\u7EC4\u7EC7\u6D3B\u52A8",
        desc: "\u548C\u672C\u5730\u7684\u793E\u533A\u5C0F\u4F19\u4F34\u4E00\u8D77\u805A\u805A\uFF0C\u6DA8\u201C\u59FF\u52BF\u201D\uFF01",
        button: "\u524D\u5F80\u67E5\u770B",
        link: "https://pingkai.cn/tidbcommunity/regional-meetup",
        image: "/images/activities/regional-meetup.jpg"
    }, 
];
function EventsIndexAbout(props) {
    var events = props.events;
    var cardRef = (0,react.useRef)();
    var cardSize = (0,useSize/* default */.Z)(cardRef);
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    var isVerticalCard = (cardSize === null || cardSize === void 0 ? void 0 : cardSize.width) < 500;
    var getDesc = function(desc) {
        var descLength = 50;
        return desc.length > descLength ? desc.substr(0, descLength) + "..." : desc;
    };
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
        isSmallScreen: isSmallScreen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                gutter: [
                    64,
                    64
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftPanel, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: "\u7279\u8272\u4E13\u533A"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Desc, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "TiDB \u793E\u533A\u81EA\u6210\u7ACB\u4EE5\u6765\uFF0C\u6BCF\u5E74\u90FD\u4F1A\u4E3E\u529E\u4E0A\u767E\u573A\u4E30\u5BCC\u591A\u5F69\u7684\u6D3B\u52A8\uFF0C\u8986\u76D6\u4E86\u5168\u7403\u51E0\u4E07\u540D\u6765\u81EA\u4E0D\u540C\u9886\u57DF\u7684\u5F00\u53D1\u8005\u3001TiDB \u7528\u6237\u548C\u7231\u597D\u8005\u3002"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "\u4F60\u53EF\u4EE5",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "#".concat(htmlId),
                                                    children: "\u5728\u6B64"
                                                }),
                                                "\u5904\u7B5B\u9009\u67E5\u770B\u5386\u5E74\u6D3B\u52A8\u5217\u8868\uFF0C \u4E5F\u53EF\u4EE5\u901A\u8FC7",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                    href: "/contact-us/cooperation",
                                                    children: "\u8868\u5355"
                                                }),
                                                "\u8054\u7CFB\u6211\u4EEC\uFF0C \u63D0\u4EA4\u4F60\u7684\u6D3B\u52A8\u521B\u610F\uFF0CTiDB \u793E\u533A\u671F\u5F85\u4F60\u7684\u53C2\u4E0E\u3002"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardList, {
                                    children: card.map(function(v) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card, {
                                            ref: cardRef,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardImg, {
                                                    $isVertical: isVerticalCard,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        unoptimized: true,
                                                        alt: v.title,
                                                        src: utils/* cdn.getImageUrl */.cK.getImageUrl(v.image),
                                                        layout: "fill",
                                                        objectFit: "cover"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardInfo, {
                                                    $isVertical: isVerticalCard,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                            children: v.title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: getDesc(v.desc)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* default */.Z, {
                                                            href: v.link,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.Z, {
                                                                type: "primary",
                                                                size: "small",
                                                                children: v.button
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, v.title);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RightPanel, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopSection, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                    children: "\u6D3B\u52A8\u65E5\u5386"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarCard, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MyFullCalendar */.h7, {
                                        data: (ref = events.map(function(val, idx) {
                                            var image = utils/* common.getStrapiImgProps */.y0.getStrapiImgProps(val.image);
                                            return About_component_objectSpread({
                                                key: idx
                                            }, val, {
                                                image: image
                                            });
                                        })) !== null && ref !== void 0 ? ref : []
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/events/index/about/index.ts


// EXTERNAL MODULE: ./src/pages/home/subscription/subscription.styled.js + 1 modules
var subscription_styled = __webpack_require__(35560);
;// CONCATENATED MODULE: ./src/pages/events/index/cooperation/cooperation.styled.ts
function cooperation_styled_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function cooperation_styled_templateObject() {
    var data = cooperation_styled_taggedTemplateLiteral([
        "\n      ",
        " {\n        text-align: center;\n      }\n    "
    ]);
    cooperation_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function cooperation_styled_templateObject1() {
    var data = cooperation_styled_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    cooperation_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function cooperation_styled_templateObject2() {
    var data = cooperation_styled_taggedTemplateLiteral([
        "\n  p {\n    font-size: 18px;\n    margin-bottom: 0;\n  }\n"
    ]);
    cooperation_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function cooperation_styled_templateObject3() {
    var data = cooperation_styled_taggedTemplateLiteral([
        "\n  text-align: right;\n"
    ]);
    cooperation_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function cooperation_styled_templateObject4() {
    var data = cooperation_styled_taggedTemplateLiteral([
        "\n  height: 150px;\n"
    ]);
    cooperation_styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var TwoColumns = (0,styled_components_browser_esm/* default */.ZP)(subscription_styled/* TwoColumns */.VZ)(cooperation_styled_templateObject1(), function(props) {
    return props.$isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(cooperation_styled_templateObject(), cooperation_styled_RightPanel);
});
var cooperation_styled_LeftPanel = styled_components_browser_esm/* default.div */.ZP.div(cooperation_styled_templateObject2());
var cooperation_styled_RightPanel = styled_components_browser_esm/* default.div */.ZP.div(cooperation_styled_templateObject3());
var Logo = styled_components_browser_esm/* default.img.attrs */.ZP.img.attrs({
    src: utils/* cdn.getImageUrl */.cK.getImageUrl("/images/events/event-logos.png")
})(cooperation_styled_templateObject4());

;// CONCATENATED MODULE: ./src/pages/events/index/cooperation/Cooperation.component.tsx





function Cooperation() {
    var isSmallScreen = (0,useIsSmallScreen/* default */.Z)().isSmallScreen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* Container */.W2, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwoColumns, {
            $isSmallScreen: isSmallScreen,
            leftPanel: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cooperation_styled_LeftPanel, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "TiDB \u793E\u533A\u81F4\u529B\u4E8E\u65B0\u6280\u672F\u65B0\u601D\u60F3\u7684\u53D1\u5C55\u4E0E\u4F20\u64AD\uFF0C\u5982\u679C\u4F60\u6B63\u5728\u7EC4\u7EC7\u4E00\u573A TiDB \u76F8\u5173\u7684\u6D3B\u52A8\uFF0C\u6B22\u8FCE\u8054\u7CFB\u6211\u4EEC\u63D0\u4F9B\u5408\u4F5C\u4E0E\u652F\u6301\u3002"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/contact-us/cooperation",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(subscription_styled/* ActionButton */.Kk, {
                            children: "\u6D3B\u52A8\u5408\u4F5C"
                        })
                    })
                ]
            }),
            rightPanel: /*#__PURE__*/ (0,jsx_runtime.jsx)(cooperation_styled_RightPanel, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {})
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/pages/events/index/cooperation/index.ts


;// CONCATENATED MODULE: ./src/pages/events/index/list/index.ts


;// CONCATENATED MODULE: ./src/pages/events/index.page.tsx







var __N_SSP = true;
var index_page_defaultPageSize = 8;
function EventsIndexPage(props) {
    var events = props.events, total = props.total, calendarEvents = props.calendarEvents;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: "\u793E\u533A\u6D3B\u52A8",
                description: "TiDB \u793E\u533A\u81EA\u6210\u7ACB\u4EE5\u6765\uFF0C\u6BCF\u5E74\u90FD\u4F1A\u4E3E\u529E\u5404\u7C7B\u4E30\u5BCC\u591A\u5F69\u7684\u6D3B\u52A8\uFF0C\u8986\u76D6\u4E86\u5168\u7403\u51E0\u4E07\u540D\u6765\u81EA\u4E0D\u540C\u9886\u57DF\u7684\u5F00\u53D1\u8005\u3001TiDB \u7528\u6237\u548C\u7231\u597D\u8005\u3002\u5728\u8FD9\u91CC\u4F60\u53EF\u4EE5\u4E86\u89E3 TiDB \u793E\u533A\u5373\u5C06\u4E3E\u529E\u7684\u7EBF\u4E0A\u3001\u7EBF\u4E0B\u7684\u6D3B\u52A8\u3001meetup \u548C\u7ADE\u8D5B\u7B49\u4FE1\u606F\u3002"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* CoreLayout */.N, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsIndexAbout, {
                        events: calendarEvents
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                        events: events,
                        total: total
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Cooperation, {})
                ]
            })
        ]
    });
};


/***/ }),

/***/ 35560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kk": function() { return /* binding */ ActionButton; },
  "W2": function() { return /* binding */ Container; },
  "U5": function() { return /* binding */ EmailInput; },
  "Hz": function() { return /* binding */ LegalCheckbox; },
  "rU": function() { return /* binding */ Link; },
  "ne": function() { return /* binding */ Slogan; },
  "ov": function() { return /* binding */ TermCaption; },
  "VZ": function() { return /* binding */ TwoColumns; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 5 modules
var input = __webpack_require__(79531);
// EXTERNAL MODULE: ./node_modules/antd/es/checkbox/index.js + 2 modules
var es_checkbox = __webpack_require__(32808);
// EXTERNAL MODULE: ./packages/ui/src/colors.ts
var colors = __webpack_require__(22745);
// EXTERNAL MODULE: ./packages/ui/src/mixins.ts
var mixins = __webpack_require__(52873);
// EXTERNAL MODULE: ./packages/ui/src/styled.ts
var styled = __webpack_require__(78763);
// EXTERNAL MODULE: ./src/layouts/twoColumnsSection/index.ts + 2 modules
var twoColumnsSection = __webpack_require__(89501);
// EXTERNAL MODULE: ./src/utils/index.js + 2 modules
var utils = __webpack_require__(49714);
;// CONCATENATED MODULE: ./src/pages/home/home.utils.js

var getImage = function(name) {
    return utils/* cdn.getImageUrl */.cK.getImageUrl("/images/home/".concat(name));
};

// EXTERNAL MODULE: ./src/components/Anchor.tsx
var Anchor = __webpack_require__(580);
;// CONCATENATED MODULE: ./src/pages/home/subscription/subscription.styled.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n      text-align: center;\n\n      ",
        " {\n        margin-bottom: 3rem;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  && {\n    background-image: url(",
        ");\n    background-size: cover;\n    padding: 4rem 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n  font-size: 14px;\n  line-height: 1;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: inherit;\n  font-size: inherit;\n  text-decoration: underline;\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n          cursor: not-allowed;\n          opacity: 70%;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 2rem;\n  max-width: 350px;\n\n  && {\n    .ant-input-search-button {\n      ",
        ";\n      ",
        ";\n      font-size: 16px;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: 8px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}






var TwoColumns = (0,styled_components_browser_esm/* default */.ZP)(twoColumnsSection/* default */.Z)(_templateObject1(), colors.F1, function(props) {
    return props.isSmallScreen && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), mixins/* flexCenter */._7(), ActionButton);
});
var Container = (0,styled_components_browser_esm/* default */.ZP)(styled/* Section */.$0)(_templateObject2(), getImage("subscription-background.svg"));
var Slogan = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var TermCaption = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var Link = (0,styled_components_browser_esm/* default */.ZP)(Anchor/* default */.Z)(_templateObject5());
var ActionButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).attrs({
    type: "primary",
    ghost: true
})(_templateObject6());
var EmailInput = (0,styled_components_browser_esm/* default */.ZP)(input/* default.Search */.Z.Search).attrs(function(props) {
    return {
        allowClear: true,
        size: "large",
        onSearch: !props.$submitDisabled && props.onSubmit
    };
})(_templateObject8(), function(props) {
    return props.$submitDisabled && (0,styled_components_browser_esm/* css */.iv)(_templateObject7());
}, mixins/* verticalLineMiddle */.XK("40px"));
var LegalCheckbox = (0,styled_components_browser_esm/* default */.ZP)(es_checkbox/* default */.Z)(_templateObject9());


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,4661,9774,2888,179], function() { return __webpack_exec__(20935); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);